import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLineChart, faUsers, faBriefcase, faFileWaveform, faSquareArrowUpRight, faBook } from '@fortawesome/free-solid-svg-icons';
import QprList from './Qpr/Lsit';
import MprList from './Mpr/Lsit';
import TeamList from './Team/List';
import Template from './Templates/Template';
import ProgrammeManual from './Templates/ProgrammeManual';
import { useSelector } from 'react-redux';

const Home = () => {
  const auth = useSelector((state) => state.auth);
  const [inner_page, setInnerPage] = useState("");
  const getInnerPage = (page) => {
    setInnerPage(page);
  }
  
  const Default = () => {
    return (
      <>
        

          <div className="single-slider slider-2 bg_cover" style={{ "backgroundImage": "url(/images/slider/slide-2.jpg)", "height": "400px" }} data-overlay="4">
              {/* <div className="container">
                  <div className="row">
                      <div className="offset-xl-2 offset-lg-2 col-xl-9 col-lg-10">
                          <div className="slider-cont">
                              <h1 data-animation="bounceInLeft" data-delay="1s">Passionate about Building a Resilient Future?</h1>
                          </div>
                      </div>
                  </div>
              </div> */}
          </div>
      </>
    )
  }

  return (
    <>
      {/* <section id="page-banner" className="pt-10 pb-10 bg_cover" data-overlay="8" style={{ backgroundImage: "url(../images/fellowship-programme.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-banner-cont">
                <h2>Home</h2>
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to={"/"}>Home</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">Home</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <section className="pb-10 border-top content-min-height">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                {/* <div className='col-md-3 pt-20'>
                  <div className='col-md-12 dashboard-box-height shadow-lg border-info' style={{"borderTop": "3px solid"}}>
                  <div className='row'>
                      <div className='col-3 text-center text-info mt-25'>
                        <FontAwesomeIcon icon={faUsers} style={{fontSize:"50px"}} /> 
                      </div>
                      <div className='col-9 mt-35'>
                        <h6 className=''>
                          <Link to={"#"} onClick={() => getInnerPage("TeamList")} className='text-secondary'>Fellowship Team</Link>
                        </h6>
                      </div>
                    </div>
                  </div>
                </div> */}
                <a href={process.env.REACT_APP_PUBLIC_URL+"/user/authenticate.php?token="+auth.token} target="_blank" className='col-md-3 pt-20'>
                  <div className='col-md-12 dashboard-box-height shadow-lg border-warning' style={{"borderTop": "3px solid"}}>
                    <div className='row'>
                      <div className='col-3 text-center text-warning mt-25'>
                        <FontAwesomeIcon icon={faFileWaveform} style={{fontSize:"50px"}} /> 
                      </div>
                      <div className='col-9 mt-30'>
                        <h6 className=''>
                          Application Form -
                          Fellowship 2025-2026
                        </h6>
                      </div>
                    </div>
                  </div>
                </a>
                <Link to={"#"} onClick={() => getInnerPage("ProgrammeManual")} className='col-md-3 pt-20'>
                  <div className='col-md-12 dashboard-box-height shadow-lg border-primary' style={{"borderTop": "3px solid"}}>
                    <div className='row'>
                      <div className='col-3 text-center text-primary mt-25'>
                        <FontAwesomeIcon icon={faBook} style={{fontSize:"50px"}} /> 
                      </div>
                      <div className='col-9 mt-35'>
                        <h6 className=''>
                          Programme Manual
                        </h6>
                      </div>
                    </div>
                  </div>
                </Link>
                <Link to={"#"} onClick={() => getInnerPage("MprList")} className='col-md-3 pt-20'>
                  <div className='col-md-12 dashboard-box-height shadow-lg border-success' style={{"borderTop": "3px solid"}}>
                    <div className='row'>
                      <div className='col-3 text-center text-success mt-25'>
                        <FontAwesomeIcon icon={faSquareArrowUpRight} style={{fontSize:"50px"}} /> 
                      </div>
                      <div className='col-9 mt-30'>
                        <h6 className=''>
                          Monthly Progress Reports
                        </h6>
                      </div>
                    </div>
                  </div>
                </Link>
                <Link to={"#"} onClick={() => getInnerPage("QprList")} className='col-md-3 pt-20'>
                  <div className='col-md-12 dashboard-box-height shadow-lg border-info' style={{"borderTop": "3px solid"}}>
                    <div className='row'>
                      <div className='col-3 text-center text-info mt-25'>
                        <FontAwesomeIcon icon={faLineChart} style={{fontSize:"50px"}} /> 
                      </div>
                      <div className='col-9 mt-30'>
                        <h6 className=''>
                          Quarterly Progress Reports
                        </h6>
                      </div>
                    </div>
                  </div>
                </Link>
                {/* <Link to={"#"} onClick={() => getInnerPage("Template")} className='col-md-4 pt-20'>
                  <div className='col-md-12 dashboard-box-height shadow-lg border-danger' style={{"borderTop": "3px solid"}}>
                    <div className='row'>
                      <div className='col-3 text-center text-danger mt-25'>
                        <FontAwesomeIcon icon={faBriefcase} style={{fontSize:"50px"}} /> 
                      </div>
                      <div className='col-9 mt-35'>
                        <h6 className=''>
                          Required Documents
                        </h6>
                      </div>
                    </div>
                  </div>
                </Link> */}
                {/* <div className='col-md-3 pt-20'>
                  <div className='col-md-12 dashboard-box-height shadow-lg border-warning' style={{"borderTop": "3px solid"}}>
                    <div className='row'>
                      <div className='col-3 text-center text-warning mt-25'>
                        <FontAwesomeIcon icon={faCheckCircle} style={{fontSize:"50px"}} /> 
                      </div>
                      <div className='col-9 mt-30'>
                        <h3 className=''>
                          <Link to={"/user/proposals"} className='text-secondary'>Proposals</Link>
                        </h3>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
        <div className="container mt-3">
          {(() => {
            if (inner_page == 'TeamList'){
              return <TeamList />
            } else if (inner_page == 'MprList'){
              return <MprList />
            } else if (inner_page == 'QprList'){
              return <QprList />
            } else if (inner_page == 'Template'){
              return <Template />
            } else if (inner_page == 'ProgrammeManual'){
              return <ProgrammeManual />
            }
            return <Default />;
          })()}
        </div>
      </section>
    </>
  );
};

export default Home;